import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './MobileProductDisplay.css';
import EmailQuote from './EmailQuote';

const MobileProductDisplay = ({ product, result, formData, productUrl, newQuote }) => {
    const [imageUrl, setImageUrl] = useState(null);
    


    useEffect(() => {
        if (product && product.featured_media) {
            // Fetch the featured media (image)
            axios
                .get(`https://uvalue-calculator.nimbus.sugarprojects.com/wp-json/wp/v2/media/${product.featured_media}`)
                .then(response => {
                    setImageUrl(response.data.source_url); // Set the image URL
                })
                .catch(err => {
                    console.error('Error fetching the featured image:', err);
                });
        } else {
            setImageUrl(null); // Set the image URL
        }
    }, [product]);

    const displayUValue = () => {
        if (result && result.uvalue !== null) {
            if (typeof result.uvalue === 'number') {
                return result.uvalue.toFixed(2); // Format to 2 decimal places
            } else {
                return result.uvalue; // Return as is if it's not a number
            }
        }
        return "0.00"; // Default display if uvalue is null
    };

    const uValue = displayUValue();

    return (
        <div>
            {uValue !== '0.00' ? (
            <div className='footer-container'>
                <div className="product-info-container">
                    <div className="info-wrapper">
                        <div className="u-value-section">
                            <div className='u-value-container'>
                                {uValue !== "Calculating..." && (
                                    <div className="u-value-unit">U-Value</div>
                                )}
                                <div id="UValueDisplay" className="u-value-display">{uValue}</div>
                                {/* Conditionally render the unit based on uValue */}
                                {uValue !== "Calculating..." && (
                                    <div className="u-value-unit">W/m²K</div>
                                )}
                            </div>
                        </div>
                        {/* Conditionally render product image */}
                        {product && imageUrl ? (
                            <div className="image-wrapper">
                                <img
                                    src={imageUrl}
                                    alt={product.title.rendered}
                                    className="product-image"
                                />
                            </div>
                        ) : (
                            <p className="no-image">No image available for this product</p>
                        )}
                        <div style={{ width: "100%" }}>
                            <div style={{ marginBottom:"10px" }}>
                                {(() => {
                                    const titleText = product.title.rendered
                                    .replace(/&#8211;/g, '-')
                                    .replace(/&amp;/g, '&');
                                    if (titleText.includes('(') && titleText.includes(')')) {
                                    const titleWithoutBrackets = titleText.substring(0, titleText.lastIndexOf('(')).trim();
                                    const bracketContent = titleText.substring(
                                        titleText.lastIndexOf('(') + 1,
                                        titleText.lastIndexOf(')')
                                    ).trim();
                                    return (
                                        <>
                                        <span style={{ fontSize: '16px', color:"#575551" }}>
                                            {titleWithoutBrackets}
                                        </span>
                                        <br />
                                        <span style={{ fontSize: '12px', color: '#706F6F' }}>
                                            {bracketContent}
                                        </span>
                                        </>
                                    );
                                    }
                                    return <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{titleText}</span>;
                                })()}
                            </div>
                            <div style={{ fontSize: "12px" }} dangerouslySetInnerHTML={{ __html: product.acf?.description }} />
                        </div>
                    </div>
                </div>
                {result && result.uvalue !== '0.00' && (
                    <EmailQuote formData={formData} productUrl={productUrl} newQuote={newQuote} product={product} result={result}/>
                )}
            </div>
            ) : 
            <div className='QR-container'>
                <img className='QR-logo' src="https://uvalue-calculator.nimbus.sugarprojects.com/wp-content/uploads/2024/09/Mannok_Logo.png"/>
                <div className='QR-title'>Download the FREE Mannok U-Value Calculator App for iOS or Android</div>
                <img className='QR-code' src='https://mannok.blob.core.windows.net/mannokbuild/Mannok-QR-Code.png' />
                <div className='QR-content'>
                    Scan the QR code with your smartphone or smart device to download the Mannok U-Value Calculator. This is the first mobile app of its kind developed by an insulation manufacturer, providing a fast, accurate, and convenient way to calculate U-values using Mannok products.
                </div>
            </div>
            }
        </div>
    );    
};    

export default MobileProductDisplay;